import { useState } from 'react';

const Tabs = ({ tabs, orientation = 'horizontal', activeIndex }) => {
  const [internalActive, setInternalActive] = useState(0);
  const controlled = activeIndex !== undefined;
  const active = controlled ? activeIndex : internalActive;

  return (
    <div className={`tabs tabs--${orientation}`}>
      {tabs.map((tab, index) => (
        <button
          key={index}
          type="button"
          className={`tabs__tab ${index === active ? 'tabs__tab--active' : ''}`}
          onClick={() => {
            if (!controlled) setInternalActive(index);
            tab.onClick?.();
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;